export class UnitTags {
    /* eslint-disable */
    executeArray = (items, itemsExists) => {
      let units = [];

      for (let unit of itemsExists?.units) {
        let unitsTagsServer = items.filter(x => x.unitId == unit.id ||  x.id == unit.id);

        let unitTags = []
        for (let unitTag of unitsTagsServer) {
          const tagId = unitTag?.tagId;
          let tag;

          if (tagId !== '-1') {
              tag = itemsExists.tags?.find(t => t?.id == tagId);
          } else {
              tag = {
                  id: '-1',
                  tagId: '-1',
                  label: 'Untagged',
                  color: '000000',
                  parentId: null,
                  path: ''
              };
          }

          unitTags.push(this.getProcessItem({}, tag));
        }
        // If there are tags different from "-1", remove the tag "-1"
        const validTags = unitTags.filter(t => {
          // Discard empty objects and avoid including tag "-1"
          if(Object.keys(t).length === 0) return false;
          return t.tagId !== '-1' && t.id !== '-1';
        });

        if (validTags.length > 0) {
          unitTags = validTags;
        }
  
        units.push({ ...unit, tags: unitTags });
      }

      //add all values from socket
      return [true, { units: units, unitTags: [...items] }]
    }
  
    getProcessItem = (item, newItem) => {

      if(!newItem && item){
        return item;
      } 

      if(!item){
        return {}
      } 

      let objItem = {
        ...item,
        id: newItem.id,
        label: newItem.label,
        color: newItem.color,
        parentId: newItem.parentId,
        path: newItem.path,
        hasChildren: newItem.hasChildren
      }
  
      return objItem
    }
  }